export default __webpack_public_path__ + "static/media/ic_somaliland.e6cd761b.svg";